import WebTheme from "./SubComponentes/WebTheme";
import {RotuloWebPequeno} from "./SubComponentes/CajasTexto";
import {Button, TextField, Alert,Box} from '@mui/material';
import {useState} from "react";


export default function WebMail({estiloPagina,onSendMail})
{
    const [form, setForm] = useState({ name: '', surname:'', email: '', message: '' });

    const formLabelStyle = {
        color: (estiloPagina.background === 'black')?WebTheme.colors.letraDark:WebTheme.colors.letraGreenRotulo,
        fontWeight: 'bold',
        fontSize: WebTheme.fontSizes.small,
    }

    /* Bordes de cajas de formulario */
    const formBoxStyle = {
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: (estiloPagina.background === 'black')?WebTheme.colors.letraDark:WebTheme.colors.letraGreen,
            },
            '&:hover fieldset': {
                borderColor: 'blue',  // borde al hacer hover
            },
            '&.Mui-focused fieldset': {
                borderColor: '#6c3483',   // borde al enfocar
            },
        },
    }
    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    function handleSubmit(e)
    {
        e.preventDefault();
        onSendMail(form.name,form.surname,form.email,form.message)
        setForm({
            name: '',
            surname: '',
            email: '',
            message: ''
        });
    }

    return(
        <Box sx = {formBoxStyle}>
            <RotuloWebPequeno estiloPagina={estiloPagina} texto = {"Correo web"} ></RotuloWebPequeno>
                 <form onSubmit={handleSubmit} >
                <TextField
                    variant="outlined"
                    fullWidth label="Nombre:" name="name" required
                    value={form.name} onChange={handleChange} margin="normal"
                    InputLabelProps={{
                        sx: formLabelStyle
                    }}
                    sx = {formBoxStyle}
                />
                <TextField
                    fullWidth label="Apellidos:" name="surname" required
                    value={form.surname} onChange={handleChange} margin="normal"
                    InputLabelProps={{
                        sx: formLabelStyle
                    }}
                    sx = {formBoxStyle}
                />
                <TextField
                    fullWidth label="Correo electrónico" name="email" type="email" required
                    value={form.email} onChange={handleChange} margin="normal"
                    InputLabelProps={{
                        sx: formLabelStyle
                    }}
                    sx = {formBoxStyle}
                />
                <TextField
                    fullWidth label="Mensaje" name="message" multiline rows={13} required
                    value={form.message} onChange={handleChange} margin="normal"
                    InputLabelProps={{
                        sx: formLabelStyle
                    }}
                    sx = {formBoxStyle}
                />
                <Button type="submit" variant="contained" className='btEnvio'
                        sx={ { mt: 2,margin:'auto',display:'flex',align:'center',height:'5%'}} >
                    Enviar
                </Button>
            </form>
        </Box>
    )

}